export const readFileAsDataUrl = file => {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.readAsDataURL(file);
  });
};

export const isAlicloudUrl = url => url.includes('aliyuncs.com');
